export default function ANB() {
  return (
    <svg
      width="24"
      height="11"
      viewBox="0 0 24 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6057_225)">
        <path
          d="M7.27364 5.23115V10.4897H5.69372V5.23115C5.69372 4.9165 5.49289 4.74244 5.40586 4.68554C5.31883 4.62864 5.09121 4.51148 4.80335 4.62864C3.76904 5.08721 2.79163 5.66295 1.87113 6.35249C1.69707 6.46629 1.61339 6.66713 1.61339 6.87131C1.61339 6.98512 1.64351 7.21608 1.87113 7.36002C2.67448 7.96253 3.5682 8.50813 4.48536 8.93993L4.11046 10.5198C2.96234 10.001 1.89791 9.37173 0.890377 8.62194C0.34477 8.19014 0 7.55751 0 6.86797C0 6.17843 0.314644 5.51567 0.890377 5.08721C1.89791 4.34077 2.98912 3.67801 4.13724 3.18931C4.82678 2.87466 5.63013 2.93157 6.26276 3.36336C6.89875 3.76839 7.27364 4.45793 7.27364 5.23115ZM23.0795 5.03031C22.072 4.28387 20.9808 3.62111 19.8326 3.1324L19.8025 3.18931L19.4577 4.68219C20.405 5.11399 21.2987 5.6596 22.1322 6.29223C22.3063 6.40604 22.39 6.60688 22.39 6.81106C22.39 6.92487 22.3598 7.15583 22.1322 7.29977C21.2117 7.98931 20.2343 8.56504 19.2 9.02362C18.9121 9.16755 18.6812 9.02362 18.5674 8.96671C18.4803 8.90981 18.2795 8.73575 18.2795 8.42111V0.662109H16.6996V8.42111C16.6996 9.16755 17.0745 9.88721 17.7339 10.2889C18.1088 10.5198 18.5105 10.6337 18.9423 10.6337C19.2569 10.6337 19.5749 10.5768 19.8628 10.4328C21.0109 9.91399 22.1054 9.2847 23.1096 8.50813C23.6552 8.07633 24 7.4437 24 6.75416C23.9699 6.12487 23.6251 5.46211 23.0795 5.03031ZM15.4343 5.98094C15.4343 4.34412 14.082 3.02194 12.4452 3.02194H10.1456C9.28201 3.02194 8.56569 3.74161 8.56569 4.60186V10.5232H10.1456V4.60186H12.4151C13.1916 4.60186 13.7941 5.23449 13.7941 5.98094V10.4931H15.431V5.98094H15.4343Z"
          fill="#0073CF"
        />
      </g>
      <defs>
        <clipPath id="clip0_6057_225">
          <rect
            width="24"
            height="9.97155"
            fill="white"
            transform="translate(0 0.662109)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
